import React, { useState } from 'react';
import { Code2, Linkedin, Github, Instagram, CreditCard } from 'lucide-react';
import { PaymentModal } from './PaymentModal';
import { LegalModal, LegalDocType } from './LegalModal';
export function Footer() {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [legalDoc, setLegalDoc] = useState<LegalDocType | null>(null);
  return <footer className="bg-black border-t border-white/5 pt-16 pb-8" data-id="element-123">
      <div className="container mx-auto px-6 md:px-12" data-id="element-124">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-125">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-126">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-127">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center text-white" data-id="element-128">
                <Code2 size={18} data-id="element-129" />
              </div>
              <span className="font-heading font-bold text-xl tracking-tight text-white" data-id="element-130">
                Mike's <span className="text-blue-500" data-id="element-131">Pro</span> Web Design
              </span>
            </a>
            <p className="max-w-sm mb-6 leading-relaxed text-[#FFFFFF]" data-id="element-132">
              Custom, high-converting websites built directly by the owner. No
              agency overhead, just pure results and dedicated service.
            </p>
            <div className="flex gap-4" data-id="element-133">
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-134">
                <Linkedin size={18} data-id="element-135" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-136">
                <Instagram size={18} data-id="element-137" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-138">
                <Github size={18} data-id="element-139" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-140">
            <h4 className="text-white font-bold mb-6" data-id="element-141">Quick Links</h4>
            <ul className="space-y-3" data-id="element-142">
              <li data-id="element-143">
                <a href="#services" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-144">
                  Services
                </a>
              </li>
              <li data-id="element-145">
                <a href="#portfolio" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-146">
                  Portfolio
                </a>
              </li>
              <li data-id="element-147">
                <a href="#process" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-148">
                  Process
                </a>
              </li>
              <li data-id="element-149">
                <a href="#pricing" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-150">
                  Pricing
                </a>
              </li>
              <li data-id="element-151">
                <a href="#faq" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-152">
                  FAQ
                </a>
              </li>
              <li data-id="element-153">
                <button type="button" onClick={() => setIsPaymentOpen(true)} className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-medium transition-colors" data-id="element-154">
                  <CreditCard size={16} data-id="element-155" />
                  Make a Payment
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-156">
            <h4 className="text-white font-bold mb-6" data-id="element-157">Contact</h4>
            <ul className="space-y-3" data-id="element-158">
              <li className="text-[#FFFFFF]" data-id="element-159">Los Angeles, CA</li>
              <li data-id="element-160">
                <a href="tel:818-381-9905" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-161">
                  818-381-9905
                </a>
              </li>
              <li data-id="element-162">
                <a href="mailto:mrross23@gmail.com" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-163">
                  mikesproweb@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-164">
          <p className="text-sm text-[#FFFFFF]" data-id="element-165">
            &copy; {new Date().getFullYear()} Mike's Pro Web Design. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-166">
            <button type="button" onClick={() => setLegalDoc('privacy')} className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-167">
              Privacy Policy
            </button>
            <button type="button" onClick={() => setLegalDoc('terms')} className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-168">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <PaymentModal isOpen={isPaymentOpen} onClose={() => setIsPaymentOpen(false)} data-id="element-169" />

      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-170" />
    </footer>;
}